import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Pie, PieChart, Cell, Legend, Area, AreaChart, Bar, BarChart } from "recharts";
import {
    Container, Row, Col, Button, CardBody, Card, Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import Flag from "../../assets/images/custom/malaysiaflag.jpg"
import MalaysiaMap from "./Map"
import Papa from "papaparse";
import { API_URL, IMAGE_URL } from "../../global";


const ChartsComponent = () => {
    const COLORS = ["#808080", "#6ee7b7", "#fca5a5", "#fdba74", "#D2B48C", "#fbbf24"];

    const [chartData, setChartData] = useState([]);
    const [chartsData1, setChartsData1] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        fetch("/passports.csv")
            .then((response) => response.text())
            .then((text) => {
                Papa.parse(text, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (result) => {
                        processData(result.data);
                    },
                });
            })
            .catch((error) => console.error("Error loading CSV:", error));
    }, []);

    const processData = (data) => {
        const yearlyData = {};

        data.forEach((row) => {
            if (row.state !== "Malaysia" || row.office !== "All") return;

            const year = row.date.split("-")[0]; // Extract year from '2020-01-01'
            const passportsCount = parseInt(row.passports.replace(/,/g, ""), 10) || 0; // Convert to number

            if (year >= 2020 && year <= 2025) {
                yearlyData[year] = (yearlyData[year] || 0) + passportsCount;
            }
        });

        // Convert object to array format for Recharts
        const formattedData = Object.keys(yearlyData).map((year) => ({
            year,
            passports: yearlyData[year],
        }));

        setChartData(formattedData);
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}/dash_data`);
            if (!response.ok) throw new Error("Failed to fetch patient data");
            const data = await response.json();
            setChartsData1(data);
        } catch (error) {
            console.error("Error fetching patients:", error);
        } finally {
            setLoading(false);
        }
    };

    // UseEffect hook to fetch data on component mount
    useEffect(() => {
        fetchData();
    }, []);

    console.log('chartsData1',chartsData1)

    // Helper function to calculate the week number from a date string
    const getWeekNumber = (date) => {
        const d = new Date(date);
        const start = new Date(d.getFullYear(), 0, 1);
        const diff = d - start;
        const oneDay = 1000 * 60 * 60 * 24;
        const weekNumber = Math.ceil((diff / oneDay + start.getDay() + 1) / 7);
        return weekNumber;
    };

    const normalizeData = (data) => {
        if (!data) return {}; // If no data, return empty object

        return {
            titleList: data.title_list ? data.title_list.map((item) => ({ title: item[0], count: item[1] })) : [],
            genderList: data.gender_list ? data.gender_list.map((item) => ({ gender: item[0], date: item[1], count: item[2] })) : [],
            dateList: data.date_list ? data.date_list.map((item) => ({ date: item[0], count: item[1] })) : []
        };
    };

    // Only normalize data if chartsData1 is not null
    const normalizedData = chartsData1 ? normalizeData(chartsData1) : {};

    if (loading) return <div>Loading...</div>;

    if (!chartsData1 || !normalizedData.titleList || !normalizedData.genderList || !normalizedData.dateList) {
        return <div>No data available</div>;
    }

    // Helper function to sanitize data
    const sanitizeData = (data) => {
        return data.map(item => ({
            name: item.name,
            value: isNaN(item.value) ? 0 : item.value,  // Replace NaN with 0
        }));
    };

    // Process Male and Female Data by Week
    const aggregateByWeek = (dataList, gender) => {
        const weeklyData = [];
        const weekCounts = {};
        let weekCounter = 1;

        dataList.forEach(item => {
            if (item.gender !== gender) return;

            const weekNumber = getWeekNumber(item.date);
            if (!weekCounts[weekNumber]) {
                weekCounts[weekNumber] = { count: 0, displayName: `Week ${weekCounter}` };
                weekCounter++;
            }
            weekCounts[weekNumber].count += item.count;
        });

        for (let week in weekCounts) {
            weeklyData.push({ name: weekCounts[week].displayName, value: weekCounts[week].count });
        }

        // Sort by sequential week order
        return weeklyData.sort((a, b) => {
            const weekA = parseInt(a.name.replace('Week ', ''));
            const weekB = parseInt(b.name.replace('Week ', ''));
            return weekA - weekB;
        });
    };

    // Aggregating male and female counts by week
    const maleCounts = aggregateByWeek(normalizedData.genderList, 'Male');
    const femaleCounts = aggregateByWeek(normalizedData.genderList, 'Female');

    // Chart 1: Titles and Counts (X: Titles, Y: Counts)
    const titleData = normalizedData.titleList.map(item => ({
        name: item.title,
        value: item.count
    }));

    // Chart 2 & 3: Male and Female Counts (X: Date, Y: Count)
    const maleData = [];
    const femaleData = [];
    const last10Days = [];
    const today = new Date();
    const last10DaysSet = new Set();

    normalizedData.genderList.forEach(item => {
        const date = new Date(item.date);
        if (today - date <= 10 * 24 * 60 * 60 * 1000) {
            last10DaysSet.add(date.toLocaleDateString());
            if (item.gender === 'Male') {
                maleData.push({ name: date.toLocaleDateString(), value: item.count });
            } else if (item.gender === 'Female') {
                femaleData.push({ name: date.toLocaleDateString(), value: item.count });
            }
        }
    });

    // Chart 4: Weekly Counts (X: Week, Y: Count)
    const weeklyData = [];
    const weekCounts = {};
    let weekCounter = 1; // Counter for sequential weeks

    // Group dates into weeks and accumulate counts
    normalizedData.dateList.forEach(item => {
        const weekNumber = getWeekNumber(item.date);
        if (!weekCounts[weekNumber]) {
            weekCounts[weekNumber] = { count: 0, displayName: `Week ${weekCounter}` };
            weekCounter++;
        }
        weekCounts[weekNumber].count += item.count;
    });

    // Convert week counts to an array with sequential week names
    for (let week in weekCounts) {
        weeklyData.push({ name: weekCounts[week].displayName, value: weekCounts[week].count });
    }

    // Sort by the sequence of weeks
    weeklyData.sort((a, b) => {
        const weekA = parseInt(a.name.replace('Week ', ''));
        const weekB = parseInt(b.name.replace('Week ', ''));
        return weekA - weekB;
    });

    // Sanitize all your chart data before passing them to the charts
    const sanitizedTitleData = sanitizeData(titleData);
    const sanitizedMaleCounts = sanitizeData(maleCounts);
    const sanitizedFemaleCounts = sanitizeData(femaleCounts);
    const sanitizedWeeklyData = sanitizeData(weeklyData);


console.log("📌 Sanitized Title Data:", sanitizedTitleData);
console.log("📌 Sanitized Male Counts:", sanitizedMaleCounts);
console.log("📌 Sanitized Female Counts:", sanitizedFemaleCounts);
console.log("📌 Sanitized Weekly Data:", sanitizedWeeklyData);


    return (
        <div className="grid grid-cols-4 gap-4">
            <Row>
                {/* Total Titles */}
                <Col md="3">
                    <Card className="stats-card">
                        <CardBody className="stats-body">
                            <div className="stats-header">
                                <h2 className="stats-title">Total Titles</h2>
                            </div>
                            <p>Types of cases</p>
                            <ResponsiveContainer width="100%" height={130}>
                                <AreaChart data={sanitizedTitleData}>
                                    <XAxis dataKey="name" hide />
                                    <YAxis hide />
                                    <Tooltip />
                                    <Area type="monotone" dataKey="value" stroke="#8884d8" fill="#8884d8" />
                                    <Line type="monotone" dataKey="value" stroke="#8884d8" strokeWidth={2} dot={false} />
                                </AreaChart>
                            </ResponsiveContainer>
                        </CardBody>
                    </Card>
                </Col>

                {/* Male Counts */}
                <Col md="3">
                    <Card className="stats-card">
                        <CardBody className="stats-body">
                            <div className="stats-header">
                                <h2 className="stats-title">Male Counts</h2>
                            </div>
                            <p>Counts per week</p>
                            <ResponsiveContainer width="100%" height={130}>
                                <AreaChart data={sanitizedMaleCounts}>
                                    <XAxis dataKey="name" hide />
                                    <YAxis hide />
                                    <Tooltip />
                                    <Area type="monotone" dataKey="value" stroke="#ff6384" fill="#ff6384" />
                                    <Line type="monotone" dataKey="value" stroke="#ff6384" strokeWidth={2} dot={false} />
                                </AreaChart>
                            </ResponsiveContainer>
                        </CardBody>
                    </Card>
                </Col>

                {/* Female Counts */}
                <Col md="3">
                    <Card className="stats-card">
                        <CardBody className="stats-body">
                            <div className="stats-header">
                                <h2 className="stats-title">Female Counts</h2>
                            </div>
                            <p>Counts per week</p>
                            <ResponsiveContainer width="100%" height={130}>
                                <AreaChart data={sanitizedFemaleCounts}>
                                    <XAxis dataKey="name" hide />
                                    <YAxis hide />
                                    <Tooltip />
                                    <Area type="monotone" dataKey="value" stroke="#ffce56" fill="#ffce56" />
                                    <Line type="monotone" dataKey="value" stroke="#ffce56" strokeWidth={2} dot={false} />
                                </AreaChart>
                            </ResponsiveContainer>
                        </CardBody>
                    </Card>
                </Col>

                {/* Weekly Counts */}
                <Col md="3">
                    <Card className="stats-card">
                        <CardBody className="stats-body">
                            <div className="stats-header">
                                <h2 className="stats-title">Total Cases</h2>
                            </div>
                            <p>Counts per week</p>
                            <ResponsiveContainer width="100%" height={130}>
                                <AreaChart data={sanitizedWeeklyData}>
                                    <XAxis dataKey="name" hide />
                                    <YAxis hide />
                                    <Tooltip formatter={(value) => [value, `value`]} />
                                    <Area type="monotone" dataKey="value" stroke="#4caf50" fill="#4caf50" />
                                    <Line type="monotone" dataKey="value" stroke="#4caf50" strokeWidth={2} dot={false} />
                                </AreaChart>
                            </ResponsiveContainer>
                        </CardBody>
                    </Card>
                </Col>


                <style jsx>{`
    .stats-card {
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      border: none;
      background-color: #fff;
      border-radius: 8px;
    }

    .stats-body {
      padding: 16px;
    }

    .stats-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .stats-title {
      font-size: 1.125rem;
      font-weight: 600;
      color: #333;
    }

    .stats-value {
      font-size: 2rem;
      font-weight: 700;
      color: #000;
      margin: 8px 0;
    }

    .stats-change {
      font-weight: 500;
      display: flex;
      align-items: center;
      font-size: 1rem;
      margin-bottom: 10px;
    }

    .positive {
      color: #22c55e;
    }

    .negative {
      color: red;
    }

    .tooltip-box {
      background-color: rgba(0, 0, 0, 0.75);
      color: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      font-size: 14px;
    }
  `}</style>
            </Row>
            <Col md="12">
                <Card
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        backgroundColor: "#fff",
                        padding: "16px",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        minHeight: "500px",
                    }}
                >
                    <div style={{ width: "100%", height: "500px", backgroundColor: "#fff", padding: "20px", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Total Passports Issued Per Year</h2>
                        <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                                <Pie
                                    data={chartData}
                                    dataKey="passports"
                                    nameKey="year"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius="80%"
                                    fill="#60a5fa"

                                >
                                    {chartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                                <Legend />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>

                    {/* Separator Line */}
                    <div style={{ width: "1px", color: "black", height: "90%" }}></div>

                    <div style={{
                        flex: "0 0 66.67%",
                        paddingLeft: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%"
                    }}>
                        <MalaysiaMap />
                    </div>
                </Card>
            </Col>
        </div >
    );
};

export default ChartsComponent;